<template>
  <div class="principal-body">
    <div @click="goBack">
      <v-icon style="margin-right: 5px; font-size: 40px">
        mdi-chevron-left
      </v-icon>
      <b>{{ $t('InvoiceChatsArchived.returnToChats') }}</b>
    </div>
    <v-divider />
    <p v-if="chats && chats.length > 0" style="text-align: center; font-style: italic ">
      {{ $t('InvoiceChatsArchived.head') }}
    </p>
    <v-divider />
    <div v-for="chat in chats" v-if="chats && chats.length > 0" :key="chat._id.toString()">
      <ItemListChat :chat="chat" />
      <v-divider />
    </div>
    <div v-if="!chats || (chats.length === 0)" style="text-align: center; margin-top: 10px;">
      <b>{{ $t('InvoiceChatsArchived.noChats') }}</b>
      <v-divider />
    </div>
  </div>
</template>

<script>
import ItemListChat from "components/ItemListChat";
import ApiRepository from "@/repositories/ApiRepository";
export default {
    name: "InvoiceChatsArchived",
    components: {ItemListChat},
    data () {
        return {
            chats: [],
            archivedChats: [],
        };
    },
    mounted () {
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.getChatsInformation()
                .then((res) => {
                    this.archivedChats = [];
                    this.chats = [];
                    for (let i = 0; i < res.data.chats.length; i++) {
                        if (res.data.chats[i].archived.length > 0) {
                            const chatArchived = res.data.chats[i].archived.filter(user => user === this.$user._id);
                            if (chatArchived.length > 0) {
                                this.chats.push(res.data.chats[i]);
                            }
                        }
                    }
                });
        },
        goBack () {
            this.$router.push({name: 'InvoiceChats', replace: true});
        },
    }
};
</script>

<style scoped>

</style>
